<template>
  <div class="factory-access-dashboard-right-info">
    <div class="grid gap-3">
      <h5 style="font-size: 14px;"><i class="dot"></i>작업 현황</h5>

      <f-a-tabs v-model="tab" :items="['작업별 현황', '업체별 현황', '중점대상 현황']"/>
      <f-a-buttons v-if="tab !== '중점대상 현황'" v-model="selectButton" :items="['외부작업', '내부작업', '장비']" @input="onChangeOptions"/>
      <f-a-buttons v-else v-model="selectButton2" :items="['작업별 현황', '업체별 현황']"/>

      <!-- 작업별 현황 -->
      <div v-if="tab === '작업별 현황'" class="info-body pt-4">
        <span class="flex flex-wrap items-center gap-y-4">
          <h5> {{title}} </h5>
          <vs-select v-model="step" autocomplete class="ml-auto" style="width: 120px" @input="onChangeOptions">
            <vs-select-item text="당일 누계" :value="-1"/>
            <vs-select-item v-if="selectBoardId === 981" text="당일 등록" :value="0"/>
            <!-- 내부작업은 입문/출문 사용하지 않음 -->
            <vs-select-item v-if="selectBoardId !== 981" text="당일 입문" :value="1"/>
            <vs-select-item text="당일 작업중" :value="2"/>
            <vs-select-item text="당일 작업완료" :value="3"/>
            <!-- 내부작업은 입문/출문 사용하지 않음 -->
            <vs-select-item v-if="selectBoardId !== 981" text="당일 출문" :value="4"/>
          </vs-select>
        </span>
        <vs-button class="w-full mt-2" color="secondary" type="border" @click="onClickLoad">데이터 불러오기</vs-button>

        <div class="line"></div>
        <ul class="info-body-data">
          <li v-for="item in tasks" @mouseover="onMouseover(item)" :key="item.task" @click.stop.prevent="onClickItem">
            <div class="info">
              <span class="icon" :style="{backgroundColor: item.color}"></span>
              <span>{{ item.task }}</span>
              <span class="ml-auto">{{ new Intl.NumberFormat().format(item.value) }}건</span>
            </div>
          </li>
        </ul>
        <div class="line"></div>
        <ul class="info-body">
          <li>
            <div class="info">
              <span class="icon" :style="{backgroundColor: '#535767'}"></span>
              <span>발행 총건수</span>
              <span class="ml-auto"> {{ new Intl.NumberFormat().format(tasks.reduce((acc, cur) => acc + cur.value, 0)) }}건</span>
            </div>
          </li>
        </ul>
      </div>

      <!-- 업체별 현황 -->
      <div v-if="tab === '업체별 현황'" class="info-body pt-4">
        <span class="flex items-center">
          <h5> {{title}} </h5>
          <vs-select v-model="step" autocomplete class="ml-auto" style="width: 120px" @input="onChangeOptions">
            <vs-select-item text="당일 누계" :value="-1"/>
            <vs-select-item text="당일 등록" :value="0"/>
            <vs-select-item text="당일 작업중" :value="2"/>
            <vs-select-item text="당일 작업완료" :value="3"/>
          </vs-select>
        </span>
        <div class="line"></div>
        <ul class="info-body-data">
          <li v-for="item in companyList" @mouseover="onMouseover(item)" :key="item.task" @click.stop.prevent="onClickItem">
            <div class="info">
              <span class="icon" :style="{backgroundColor: item.color}"></span>
              <span>{{ item.com_name }}</span>
              <span class="ml-auto">{{ new Intl.NumberFormat().format(item.value) }}명</span>
            </div>
            <div class="text-right">
              <p v-for="task in item.tasks">{{ task }}</p>
            </div>
          </li>
        </ul>
        <div class="line"></div>
        <ul class="info-body">
          <li>
            <div class="info">
              <span class="icon" :style="{backgroundColor: '#535767'}"></span>
              <span>총 작업자 수</span>
              <span class="ml-auto"> {{ new Intl.NumberFormat().format(companyList.reduce((acc, cur) => acc + cur.value, 0)) }}명</span>
            </div>
          </li>
        </ul>
      </div>

      <!-- 중점대상 현황 -->
      <div v-if="tab === '중점대상 현황'" class="info-body pt-4">
        <span class="flex flex-wrap items-center gap-y-4">
          <h5> {{title}} </h5>
          <vs-select v-model="step" autocomplete class="ml-auto" style="width: 120px" @input="onChangeOptions">
            <vs-select-item text="당일 누계" :value="-1"/>
            <vs-select-item text="당일 입문" :value="1"/>
            <vs-select-item text="당일 작업중" :value="2"/>
            <vs-select-item text="당일 작업완료" :value="3"/>
            <vs-select-item text="당일 출문" :value="4"/>
          </vs-select>
        </span>
        <vs-button class="w-full mt-2" color="secondary" type="border" @click="onClickLoad">데이터 불러오기</vs-button>

        <div class="line"></div>
        <template v-if="selectButton2 === '작업별 현황'" >
          <ul class="info-body-data">
            <li v-for="item in criticalTasks" @mouseover="onMouseover(item)" :key="item.task" @click.stop.prevent="onClickItem">
              <div class="info">
                <span class="icon" :style="{backgroundColor: item.color}"></span>
                <span>{{ item.task }}</span>
                <span class="ml-auto">{{ new Intl.NumberFormat().format(item.value) }}건</span>
              </div>
            </li>
          </ul>
          <div class="line"></div>
          <ul class="info-body">
            <li>
              <div class="info">
                <span class="icon" :style="{backgroundColor: '#FF6B6B'}"></span>
                <span>중점대상 총건수</span>
                <span class="ml-auto"> {{ new Intl.NumberFormat().format(criticalTasks.reduce((acc, cur) => acc + cur.value, 0)) }}건</span>
              </div>
            </li>
          </ul>
        </template>
        <template v-else>
          <ul class="info-body-data">
            <li v-for="item in companyList" @mouseover="onMouseover(item)" :key="item.task" @click.stop.prevent="onClickItem">
              <div class="info">
                <span class="icon" :style="{backgroundColor: item.color}"></span>
                <span>{{ item.com_name }}</span>
                <span class="ml-auto">{{ new Intl.NumberFormat().format(item.value) }}명</span>
              </div>
              <div class="text-right">
                <p v-for="task in item.tasks">{{ task }}</p>
              </div>
            </li>
          </ul>
          <div class="line"></div>
          <ul class="info-body">
            <li>
              <div class="info">
                <span class="icon" :style="{backgroundColor: '#535767'}"></span>
                <span>총 작업자 수</span>
                <span class="ml-auto"> {{ new Intl.NumberFormat().format(companyList.reduce((acc, cur) => acc + cur.value, 0)) }}명</span>
              </div>
            </li>
          </ul>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
import FAButtons from "@/views/project/dashboard/FactoryAccessDashboard/FAButtons.vue";
import FATabs from "@/views/project/dashboard/FactoryAccessDashboard/FATabs.vue";

export default {
  name: "FactoryAccessDashboardRightInfo",
  components: {FATabs, FAButtons},
  props: {
    title: String,
    /**
     * {
     *    regionName: '당진공장'
     *    boardId: 976,
     *    key: "976_1공장_용광로_고소작업",
     *    task: "고소작업",
     *    count: 1,
     *    countStep: {
     *      0: 1,
     *      2: 1,
     *      3: 1,
     *    },
     *    zoneIds: [zone.id],
     * }
     **/
    taskList: {
      type: Array,
      default: () => []
    },
    selectZoneId: {
      type: Number,
      default: 0
    },

    // 외부작업: 976, 내부작업: 981, 장비: 979
    selectBoardId: Number
  },
  computed: {
    tasks () {
      let result = [
        { task: '일반작업', value: 0, color: '#EA3829' },
        { task: '화기작업', value: 0, color: '#F68511' },
        { task: '고소작업', value: 0, color: '#F8D904' },
        { task: '중장비 작업', value: 0, color: '#AAD816' },
        { task: '밀폐공간 작업', value: 0, color: '#27BB36' },
        { task: '정전(전기차단)작업', value: 0, color: '#008F5D' },
        { task: '굴착작업', value: 0, color: '#0FB5AE' },
        { task: '방사선 관련 작업', value: 0, color: '#33C5E8' },
        { task: '기타', value: 0, color: '#686DF4' },
      ];

      if (this.selectButton === '장비') {
        result = [
          { task: '지게차', value: 0, color: '#EA3829' },
          { task: '이동식크레인', value: 0, color: '#F68511' },
          { task: '고소작업차', value: 0, color: '#F8D904' },
          { task: '고소작업대', value: 0, color: '#AAD816' },
          { task: '굴삭기', value: 0, color: '#27BB36' },
          { task: '기타', value: 0, color: '#686DF4' },
        ];
      } else if (this.selectButton === '중점대상 현황') {
        result = [
          { task: '고소작업', value: 0, color: '#F8D904' },
          { task: '중장비 작업', value: 0, color: '#AAD816' },
          { task: '밀폐공간 작업', value: 0, color: '#27BB36' },
          { task: '굴착작업', value: 0, color: '#0FB5AE' },
          { task: '방사선 관련 작업', value: 0, color: '#33C5E8' },
        ];
      }

      this.taskList.forEach((item) => {
        const index = result.findIndex((r) => r.task === item.task);
        if (index !== -1) {
          result[index].value += item.count;
        }
      });

      // 작업 개수로 정렬
      result.sort((a, b) => b.value - a.value);

      return result;
    },

    companyList() {
      let tasks = [
        { task: '일반작업', value: 0, color: '#EA3829' },
        { task: '화기작업', value: 0, color: '#F68511' },
        { task: '고소작업', value: 0, color: '#F8D904' },
        { task: '중장비 작업', value: 0, color: '#AAD816' },
        { task: '밀폐공간 작업', value: 0, color: '#27BB36' },
        { task: '정전(전기차단)작업', value: 0, color: '#008F5D' },
        { task: '굴착작업', value: 0, color: '#0FB5AE' },
        { task: '방사선 관련 작업', value: 0, color: '#33C5E8' },
        { task: '기타', value: 0, color: '#686DF4' },
      ];
      if (this.tab === '중점대상 현황') {
        tasks = [
          { task: '고소작업', value: 0, color: '#F8D904' },
          { task: '중장비 작업', value: 0, color: '#AAD816' },
          { task: '밀폐공간 작업', value: 0, color: '#27BB36' },
          { task: '굴착작업', value: 0, color: '#0FB5AE' },
          { task: '방사선 관련 작업', value: 0, color: '#33C5E8' },
        ];
      }

      // 중복되지 않게 post 정보를 저장한다.
      const posts = {};
      this.taskList.forEach((item) => {
        if (tasks.map(item => item.task).includes(item.task)) {
          const postIds = Object.keys(item.posts);
          for (let i = 0; i<postIds.length; i++) {
            const postId = postIds[i];
            const post = item.posts[postId];
            if (!posts[postId]) {
              posts[postId] = post;
              posts[postId].tasks = [`${item.task}`];
            } else {
              posts[postId].tasks.push(item.task);
            }
          }
        }
      });

      // post 정보로 작업자 수를 계산한다.
      const companies = {};
      const postIds = Object.keys(posts);
      for (let i = 0; i<postIds.length; i++) {
        const postId = postIds[i];
        const post = posts[postId];
        if (companies[post.companyName]) {
          companies[post.companyName].count += post.worker.length;
          for (let j = 0; j<post.tasks.length; j++) {
            if (!companies[post.companyName].tasks.includes(post.tasks[j])) {
              companies[post.companyName].tasks.push(post.tasks[j]);
            }
          }
        } else {
          companies[post.companyName] = {
            count: post.worker.length,
            tasks: [...post.tasks]
          }
        }
      }

      // 결과로 변환한다.
      const colors = ["#EA3829", "#F68511", "#F8D904", "#AAD816", "#27BB36", "#008F5D", "#0FB5AE", "#33C5E8", "#686DF4"]
      const result = Object.entries(companies).map((obj, index) => {
        return {
          com_name: obj[0],
          value: obj[1].count,
          color: colors[index % colors.length],
          tasks: obj[1].tasks.sort()
        }
      });

      // 작업 개수로 정렬
      result.sort((a, b) => b.value - a.value);
      return result;
    },

    criticalTasks () {
      console.log('🎯 [DEBUG] criticalTasks computed 시작:', {
        taskListLength: this.taskList.length,
        selectButton: this.selectButton,
        tab: this.tab
      });

      const result = [
        { task: '고소작업', value: 0, color: '#F8D904' },
        { task: '중장비 작업', value: 0, color: '#AAD816' },
        { task: '밀폐공간 작업', value: 0, color: '#27BB36' },
        { task: '굴착작업', value: 0, color: '#0FB5AE' },
        { task: '방사선 관련 작업', value: 0, color: '#33C5E8' },
      ];

      this.taskList.forEach((item, index) => {
        console.log(`🔍 [DEBUG] taskList[${index}] 처리:`, {
          task: item.task,
          count: item.count,
          zones: Object.keys(item.zones).map(zoneId => ({
            zoneId,
            zoneName: item.zones[zoneId].name,
            postIds: item.zones[zoneId].postIds
          }))
        });

        const resultIndex = result.findIndex((r) => r.task === item.task);
        if (resultIndex !== -1) {
          console.log(`✅ [DEBUG] ${item.task} 매칭됨, count ${item.count} 추가`);
          result[resultIndex].value += item.count;
        } else {
          console.log(`❌ [DEBUG] ${item.task} 매칭되지 않음`);
        }
      });

      console.log('📊 [DEBUG] criticalTasks 결과:', result);

      // 작업 개수로 정렬
      result.sort((a, b) => b.value - a.value);
      return result;
    }

  },
  watch: {
    tab (newTab, oldTab) {
      console.log('🔄 [DEBUG] 탭 변경됨:', newTab, oldTab);
      // 탭이 변경될 때마다 옵션 업데이트
      this.onChangeOptions();
    }
  },
  data () {
    return {
      steps: ['등록', '입문', '작업중', '작업완료', '출문'],
      selectButton: '외부작업',
      selectButton2: '작업별 현황',
      tab: '작업별 현황',
      step: -1,
    }
  },
  methods: {
    onMouseover (item) {
      this.$emit('mouseover', item)
    },
    onClickItem () {
    },

    getBoardId (selectButton) {
      switch (selectButton) {
        case '외부작업':
          return 976;
        case '내부작업':
          return 981;
        case '장비':
          return 979;
        default:
          return 0;
      }
    },

    onChangeOptions () {
      let boardId = 0;
      if (this.tab === '중점대상 현황') {
        boardId = 976; // 중점대상 현황은 976 게시판 사용
      } else {
        boardId = this.getBoardId(this.selectButton);
      }

      const options = {
        boardId,
        step: this.step,
        isCriticalWork: this.tab === '중점대상 현황'
      };

      console.log('📤 [DEBUG] onChangeOptions emit:', {
        tab: this.tab,
        selectButton: this.selectButton,
        options
      });

      this.$emit('changeOptions', options);
    },

    onClickLoad () {
      this.$emit('reload');
    }
  }
}
</script>

<style scoped lang="scss">
.info-body,
.info-body-data {
  li > .info {
    display: flex;
    align-items: center;
    padding: 0.375rem 0;
    .icon {
      width: 20px;
      height: 20px;
      background-color: #E6E9F4;
      border-radius: 5px;
      margin-right: 1rem;
    }
  }
}
.info-body-data {
  li {
    cursor: pointer;
    &:hover {
      background-color: #F5F6FA;
    }
  }
}
.line {
  border-top: 1px solid #E6E9F4;
  margin: 0.75rem 0;
}
</style>
